import { render } from "./PercentageBar.vue?vue&type=template&id=871e3f1c&scoped=true"
import script from "./PercentageBar.vue?vue&type=script&lang=js"
export * from "./PercentageBar.vue?vue&type=script&lang=js"

import "./PercentageBar.vue?vue&type=style&index=0&id=871e3f1c&lang=scss&scoped=true"

import exportComponent from "../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-871e3f1c"]])

export default __exports__